import React from 'react';
import { Box, TextField, Button, MenuItem, Link } from '@mui/material';

const MasProductListBox = ({ formik }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'flex-start',
        alignItems: 'center',
        my: 1,
      }}
    >
      <Box
        component="form"
        noValidate
        autoComplete="off"
        sx={{
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'flex-end',
          alignItems: 'center',
          mr: 2,
        }}
        onSubmit={formik.handleSubmit}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-start',
            alignItems: 'center',
            '& > :not(style)': { m: 1, width: '25ch' },
          }}
        >
          <TextField
            variant="standard"
            required
            select
            id="searchKeyword"
            name="searchKeyword"
            label="검색키워드"
            value={formik.values.searchKeyword}
            onChange={formik.handleChange}
            error={
              formik.touched.searchKeyword &&
              Boolean(formik.errors.searchKeyword)
            }
            helperText={
              formik.touched.searchKeyword && formik.errors.searchKeyword
            }
          >
            <MenuItem value="">검색키워드</MenuItem>
            <MenuItem value="partnerNm">제조사</MenuItem>
            <MenuItem value="productLine">제품군</MenuItem>
            <MenuItem value="productNm">제품명</MenuItem>
            <MenuItem value="modelNm">모델명</MenuItem>
            <MenuItem value="category">분류</MenuItem>
          </TextField>
          <TextField
            variant="standard"
            required
            id="searchWords"
            name="searchWords"
            label="검색어"
            onChange={formik.handleChange}
            error={
              formik.touched.searchWords && Boolean(formik.errors.searchWords)
            }
            helperText={
              formik.touched.searchWords && formik.errors.searchWords
            }
          />
        </Box>

        <Box>
          <Button
            type="submit"
            color="info"
            variant="contained"
            disabled={formik.isSubmitting}
          >
            검색
          </Button>

          <Button sx={{ mx: 2 }} component={Link} color="warning" variant="outlined" target="_blank" rel="noopener noreferrer" href="/productmng/add">제품 등록</Button>
        </Box>
      </Box>

    </Box>
  )
}

export default MasProductListBox